export const authRoutes = [
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/modules/Core/views/Index.vue'),
    menu: false,
    desplegable: false,
    icon: '',
    redirect: '/login',
    meta: {
      permiso: [],
      requiresSession: true,
      title: 'Login'
    },
    children: [
      {
        path: '/login',
        component: () =>
          import(
            /* webpackChunkName: "auth" */ '@/modules/Autenticacion/views/LoginForm.vue'
          ),
        name: 'login',
        menu: false,
        icon: '',
        meta: {
          permiso: [],
          requiresSession: false,
          title: 'Login'
        },
        children: []
      },
      {
        path: '/solicitud',
        component: () =>
          import(
            /* webpackChunkName: "auth" */ '@/modules/Core/views/SolicitudEntidadForm.vue'
          ),
        name: 'solicitudEntidad',
        menu: false,
        icon: '',
        meta: {
          permiso: [],
          requiresSession: false,
          title: 'Solicitud de entidad'
        },
        children: []
      },
      {
        path: '/recuperar',
        component: () =>
          import(
            /* webpackChunkName: "auth" */ '@/modules/Autenticacion/views/RecoverFlow.vue'
          ),
        name: 'recuperar',
        menu: false,
        icon: '',
        meta: {
          permiso: [],
          requiresSession: false,
          title: 'Recuperar contraseña'
        },
        children: []
      },
      {
        path: '/error503',
        name: 'EnMantenimiento',
        component: () =>
          import(
            /* webpackChunkName: "base" */ '@/modules/Core/views/MantenimientoIndex.vue'
          ),
        icon: 'QueueListIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'En mantenimiento',
          requiresSession: true,
          permiso: []
        },
        children: []
      }
    ]
  }
]
